//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HelloWorld from './components/HelloWorld.vue'

export default {
	name: 'LayoutDefault',

	components: {
		HelloWorld
	},

	data () {
		return {
			leftDrawerOpen: false
		}
	}
}
